import React, { Component } from 'react';
class Footer extends Component {
    componentDidMount() {
        require("./css/Footer.css");
    }
    render() {
        return(
            <div className="Footer_Container">
                <div className="Footer_Content">
                        <h2>Navigation</h2>
                    <ul className="Footer_List">
                        <li><a className="Nav_Link" href="/Members">Members</a></li>
                        <li><a className="Nav_Link" href="/Employers">Employers</a></li>
                        <li><a className="Nav_Link" href="/Brokers">Brokers</a></li>
                        <li><a className="Nav_Link" href="/Providers">Providers</a></li>
                        <li><a className="Nav_Link" href="/Forms">Forms</a></li>
                        <li><a className="Nav_Link" href="/Quote">Quoting</a></li>
                    </ul>
                </div>

                <div className="Footer_Content">

                    <h2 className="Footer_Title">Matrix Healthcare</h2>
                    <p> PO Box 58769 | Salt Lake City, UT 84158-0769</p>

                </div>
                
                <div className="Footer_Content">
                <h2 className="Footer_Title"><a className="Nav_Link" href="/About">About Us</a></h2>
                    <p><a className="Nav_Link" href="https://basbenefits.com" target="_blank" rel="noopener noreferrer">Benefits Administered<br></br><span style={{textAlign: "centered"}}>by</span><br></br> BAS Benefits</a></p>
                    <p>Benefits simplified </p>
                </div>

            </div>
        )
    }
}
export default Footer;